import { Reducer } from 'redux';
import { isType } from 'typescript-fsa';
import {
  describeDocumentPointerByRoleActions,
  createDocumentPointerActions,
  deleteDocumentPointerActions,
  updateDocumentPointerActions,
} from './documentpointer.actions';
import { pathOr } from 'ramda';
import {
  createDefaultState,
  onCreateOrUpdate,
  onError,
  onGetAllSuccess,
  onStart,
  onDeleteSuccess,
  setError,
} from 'src/store/store.helpers';
import {
  EntityError,
  MappedEntityState2 as MappedEntityState,
} from 'src/store/types';

/**
 * State
 */

export type State = MappedEntityState<any, EntityError>;

export const defaultState: State = createDefaultState();

/**
 * Reducer
 */
const reducer: Reducer<State> = (state = defaultState, action) => {
  if (isType(action, describeDocumentPointerByRoleActions.started)) {
    return onStart(state);
  }

  if (isType(action, describeDocumentPointerByRoleActions.done)) {
    const { result } = action.payload;
    return onGetAllSuccess(
      // since 1 is given as static because we have number_of_pages in 0,data will be in 1 index
      pathOr([], ['items'], result),
      state,
      pathOr([], ['items'], result)
    );
  }

  if (isType(action, describeDocumentPointerByRoleActions.failed)) {
    const { error } = action.payload;
    return onError({ read: error }, state);
  }

  if (isType(action, createDocumentPointerActions.started)) {
    return onStart(state);
  }
  if (isType(action, createDocumentPointerActions.done)) {
    const newTask = action.payload.result.data;
    return onCreateOrUpdate(newTask, state);
  }
  if (isType(action, createDocumentPointerActions.failed)) {
    const { error } = action.payload;
    return onError({ create: error }, state);
  }

  if (isType(action, deleteDocumentPointerActions.started)) {
    return setError({ delete: undefined }, state);
  }

  if (isType(action, deleteDocumentPointerActions.done)) {
    const id = action.payload.params;
    return onDeleteSuccess(id, state);
  }

  if (isType(action, deleteDocumentPointerActions.failed)) {
    const { error } = action.payload;

    return onError({ delete: error }, state);
  }
  if (isType(action, updateDocumentPointerActions.started)) {
    return {
      ...state,
      loading: true,
      lastUpdated: Date.now(),
    };
  }
  if (isType(action, updateDocumentPointerActions.done)) {
    const { payload } = action;
    const data = pathOr([], ['result', 'data'], payload);
    return onCreateOrUpdate(data, state);
  }
  if (isType(action, updateDocumentPointerActions.failed)) {
    return {
      ...state,
      loading: false,
    };
  }
  return state;
};

export default reducer;
